<!-- 创建队伍 -->
<template>
  <div>
    <!-- 创建队伍触发器 -->
    <button
      :class="$style['create-trigger']"
      style="position: absolute; top: 0.84rem; right: 1.08rem"
      @click="showCreateTeam"
    />

    <!-- 创建队伍弹窗 -->
    <popup-frame ref="create-team" size="lg">
      <div :class="$style['create-team-content']">
        <form autocomplete="off" @submit.prevent="handleCreateTeam">
          <!-- 队伍名称 -->
          <div :class="$style.field">
            <label>队伍名称：</label>
            <input v-model="teamName" maxlength="6" placeholder="请为你的队伍起个名字吧" />
          </div>
          <!-- 队伍口号 -->
          <div :class="$style.field">
            <label>队伍口号：</label>
            <input v-model="teamSlogan" maxlength="10" placeholder="请为你的队伍起个口号吧" />
          </div>
          <div style="text-align: center">
            <button :class="$style['create-submit']" />
          </div>
        </form>
        <div :class="$style['create-rule']" v-html="createTeamRule" />
      </div>
    </popup-frame>

    <!-- 确认创建弹窗 -->
    <popup-frame ref="confirm-create" size="mini">
      <div
        v-html="createTeamConfirm"
        style="margin-bottom: 0.5rem; font-size: 0.28rem; line-height: 1.8"
      />
      <button :class="$style['create-confirm']" @click="handleConfirmCreate" />
    </popup-frame>
  </div>
</template>

<script>
import { PopupFrame } from '@/components/widgets'
import { mapGetters, mapActions } from 'vuex'
import { createTeam } from '@/api'

export default {
  name: 'CreateTeam',
  components: {
    PopupFrame
  },
  data() {
    return {
      teamName: '',
      teamSlogan: ''
    }
  },
  computed: {
    ...mapGetters(['createTeamRule', 'isBindRole', 'createTeamConfirm'])
  },
  methods: {
    ...mapActions(['setTeamInfo']),
    showCreateTeam() {
      if (!this.isBindRole) {
        this.$emit('login')
        return
      }

      // 清空表单
      this.teamName = ''
      this.teamSlogan = ''

      this.$refs['create-team'].show()
    },
    handleCreateTeam() {
      if (!this.teamName || !this.teamSlogan) {
        this.$toast('请填写队伍信息')
        return
      }
      // 关闭弹窗
      this.$refs['create-team'].hide()
      // 显示确认创建弹窗
      this.$refs['confirm-create'].show()
    },
    async handleConfirmCreate() {
      const { code, data } = await createTeam({
        team_name: this.teamName,
        slogan: this.teamSlogan
      })
      // 创建成功
      if (code === 0) {
        this.$refs['confirm-create'].hide()
        // 到父组件去处理创建成功事件
        this.$emit('create-success', data)
      }
    }
  }
}
</script>

<style lang="less" module>
.create-trigger {
  .size(1.46rem, 0.58rem);
  .background-fill('./images/create-trigger.png');
}

.create-team-content {
  padding-top: 0.5rem;

  &::before {
    .size(7.08rem, 5.13rem);
    .background-fill('./images/create-title.png');

    content: '';
    position: absolute;
    top: -0;
    left: 0;
    pointer-events: none;
  }

  .field {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.5rem;

    label {
      font-family: 'Source Han Serif SC Bold';
      font-size: 0.28rem;
    }

    input {
      .size(4.62rem, 0.95rem);
      .background-fill('./images/create-input.png');

      border: 0;
      padding-left: 0.2rem;
      color: #c43137;

      &::placeholder {
        color: fade(#c43137, 50%);
      }
    }
  }
}

.create-submit {
  .size(2.35rem, 0.66rem);
  .background-fill('./images/create-submit.png');
}

.create-rule {
  margin-top: 0.5rem;
  padding: 0 0.2rem;
  font-size: 0.2rem;
  line-height: 1.8;
}

.create-confirm {
  .size(2.35rem, 0.66rem);
  .background-fill('./images/create-confirm.png');
}
</style>
